"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/payment-ach-in.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fpayment-ach-in.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.achInPaymentTypeToJSON = exports.achInPaymentTypeFromJSON = exports.AchInPaymentContext = exports.AchInPaymentType = void 0;
const date_1 = require("../common/date");
const protobufPackage = 'com.step.common.proto';
var AchInPaymentType;
(function (AchInPaymentType) {
    AchInPaymentType["INVALID_ACH_IN_PAYMENT_TYPE"] = "INVALID_ACH_IN_PAYMENT_TYPE";
    /**
     * PAYROLL - We were able to identify this ACH credit as a paycheck
     */
    AchInPaymentType["PAYROLL"] = "PAYROLL";
    /**
     * INCOME - We weren't able to identify this ACH credit as a paycheck, but it's not blacklisted
     */
    AchInPaymentType["INCOME"] = "INCOME";
    AchInPaymentType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AchInPaymentType || (exports.AchInPaymentType = AchInPaymentType = {}));
function createBaseAchInPaymentContext() {
    return {
        counterpartyCompanyDescription: '',
        counterpartyCompanyName: '',
        counterpartyCompanyId: '',
        counterpartyRoutingNumber: '',
        stepIndividualName: '',
        stepIndividualId: '',
        stepAccountOwnerUserId: '',
        effectiveDate: undefined,
        type: AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE,
        daysEarly: 0,
        companyDiscretionaryData: '',
    };
}
exports.AchInPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.counterpartyCompanyDescription)) {
            message.counterpartyCompanyDescription = globalThis.String(object.counterpartyCompanyDescription);
        }
        if (isSet(object.counterpartyCompanyName)) {
            message.counterpartyCompanyName = globalThis.String(object.counterpartyCompanyName);
        }
        if (isSet(object.counterpartyCompanyId)) {
            message.counterpartyCompanyId = globalThis.String(object.counterpartyCompanyId);
        }
        if (isSet(object.counterpartyRoutingNumber)) {
            message.counterpartyRoutingNumber = globalThis.String(object.counterpartyRoutingNumber);
        }
        if (isSet(object.stepIndividualName)) {
            message.stepIndividualName = globalThis.String(object.stepIndividualName);
        }
        if (isSet(object.stepIndividualId)) {
            message.stepIndividualId = globalThis.String(object.stepIndividualId);
        }
        if (isSet(object.stepAccountOwnerUserId)) {
            message.stepAccountOwnerUserId = globalThis.String(object.stepAccountOwnerUserId);
        }
        if (isSet(object.effectiveDate)) {
            message.effectiveDate = date_1.LocalDate.fromJSON(object.effectiveDate);
        }
        if (isSet(object.type)) {
            message.type = achInPaymentTypeFromJSON(object.type);
        }
        if (isSet(object.daysEarly)) {
            message.daysEarly = globalThis.Number(object.daysEarly);
        }
        if (isSet(object.companyDiscretionaryData)) {
            message.companyDiscretionaryData = globalThis.String(object.companyDiscretionaryData);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.counterpartyCompanyDescription !== undefined &&
            message.counterpartyCompanyDescription !== '') {
            obj.counterpartyCompanyDescription = message.counterpartyCompanyDescription;
        }
        if (message.counterpartyCompanyName !== undefined && message.counterpartyCompanyName !== '') {
            obj.counterpartyCompanyName = message.counterpartyCompanyName;
        }
        if (message.counterpartyCompanyId !== undefined && message.counterpartyCompanyId !== '') {
            obj.counterpartyCompanyId = message.counterpartyCompanyId;
        }
        if (message.counterpartyRoutingNumber !== undefined && message.counterpartyRoutingNumber !== '') {
            obj.counterpartyRoutingNumber = message.counterpartyRoutingNumber;
        }
        if (message.stepIndividualName !== undefined && message.stepIndividualName !== '') {
            obj.stepIndividualName = message.stepIndividualName;
        }
        if (message.stepIndividualId !== undefined && message.stepIndividualId !== '') {
            obj.stepIndividualId = message.stepIndividualId;
        }
        if (message.stepAccountOwnerUserId !== undefined && message.stepAccountOwnerUserId !== '') {
            obj.stepAccountOwnerUserId = message.stepAccountOwnerUserId;
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = date_1.LocalDate.toJSON(message.effectiveDate);
        }
        if (message.type !== undefined && message.type !== AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE) {
            obj.type = achInPaymentTypeToJSON(message.type);
        }
        if (message.daysEarly !== undefined && message.daysEarly !== 0) {
            obj.daysEarly = Math.round(message.daysEarly);
        }
        if (message.companyDiscretionaryData !== undefined && message.companyDiscretionaryData !== '') {
            obj.companyDiscretionaryData = message.companyDiscretionaryData;
        }
        return obj;
    },
    create(base) {
        return exports.AchInPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInPaymentContext();
        message.counterpartyCompanyDescription = object.counterpartyCompanyDescription ?? '';
        message.counterpartyCompanyName = object.counterpartyCompanyName ?? '';
        message.counterpartyCompanyId = object.counterpartyCompanyId ?? '';
        message.counterpartyRoutingNumber = object.counterpartyRoutingNumber ?? '';
        message.stepIndividualName = object.stepIndividualName ?? '';
        message.stepIndividualId = object.stepIndividualId ?? '';
        message.stepAccountOwnerUserId = object.stepAccountOwnerUserId ?? '';
        message.effectiveDate = (object.effectiveDate !== undefined && object.effectiveDate !== null)
            ? date_1.LocalDate.fromPartial(object.effectiveDate)
            : undefined;
        message.type = object.type ?? AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE;
        message.daysEarly = object.daysEarly ?? 0;
        message.companyDiscretionaryData = object.companyDiscretionaryData ?? '';
        return message;
    },
};
function achInPaymentTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACH_IN_PAYMENT_TYPE':
            return AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE;
        case 1:
        case 'PAYROLL':
            return AchInPaymentType.PAYROLL;
        case 2:
        case 'INCOME':
            return AchInPaymentType.INCOME;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AchInPaymentType.UNRECOGNIZED;
    }
}
exports.achInPaymentTypeFromJSON = achInPaymentTypeFromJSON;
function achInPaymentTypeToJSON(object) {
    switch (object) {
        case AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE:
            return 'INVALID_ACH_IN_PAYMENT_TYPE';
        case AchInPaymentType.PAYROLL:
            return 'PAYROLL';
        case AchInPaymentType.INCOME:
            return 'INCOME';
        case AchInPaymentType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.achInPaymentTypeToJSON = achInPaymentTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-ach-in.js.map